<template>
	<div class="container tac">
		<div class="m_sub_top">
			<div class="top_content">
				<p class="headline_m">
					{{ $t('rtr_business-how-receive.title1') }}<br />
					{{ $t('rtr_business-how-receive.title2') }}
				</p>
				<div class="button_area">
					<button
						class="button_bg_red mr_10"
						@click="$router.push({ name: 'auth-register' })"
					>
						{{ $t('button.signup') }}
					</button>
					<button class="button_bg_black" @click="$router.push({ name: 'cs' })">
						{{ $t('button.info') }}
					</button>
				</div>
			</div>
		</div>
		<section>
			<div class="m_sub_middle body_l">
				<p>{{ $t('rtr_business-how-receive.text1') }}</p>
				<button class="button_bg_red" @click="$router.push({ name: 'cs' })">
					{{ $t('button.start') }}
				</button>
			</div>
			<div class="content_area">
				<div class="m_sub_bottom">
					<h2 class="headline_m">
						{{ $t('rtr_business-how-receive.title3') }}
					</h2>
					<p class="body_m">
						{{ $t('rtr_business-how-receive.text2') }}
					</p>
				</div>
			</div>
		</section>

		<section>
			<div class="content_area">
				<div class="detail_area">
					<div class="detail">
						<h2 class="headline_s">
							{{ $t('rtr_business-how-receive.title4') }}
						</h2>
						<div class="img_area_02">
							<img src="@/assets/images/sub/business_receive_02.png" alt="" />
						</div>
						<div class="text mt_30">
							<p class="body_m">
								{{ $t('rtr_business-how-receive.text3') }}<br />
								{{ $t('rtr_business-how-receive.text4') }}
							</p>
						</div>
					</div>
				</div>
				<div class="detail_area">
					<div class="detail">
						<h2 class="headline_s">
							{{ $t('rtr_business-how-receive.title5') }}
						</h2>
						<div class="img_area_02">
							<img src="@/assets/images/sub/business_receive_03.png" alt="" />
						</div>
						<div class="text mt_30">
							<p class="body_m">
								{{ $t('rtr_business-how-receive.text5') }}<br />
								{{ $t('rtr_business-how-receive.text6') }}
							</p>
						</div>
					</div>
				</div>
				<div class="detail_area mb_10">
					<div class="detail">
						<h2 class="headline_s">
							{{ $t('rtr_business-how-receive.title6') }}
						</h2>
						<div class="img_area_02">
							<img src="@/assets/images/sub/business_receive_04.png" alt="" />
						</div>
						<div class="text mt_30">
							<p class="body_m">
								{{ $t('rtr_business-how-receive.text7') }}<br />
								{{ $t('rtr_business-how-receive.text8') }}
								<router-link to class="m_link_type_02" @click="notYet">{{
									$t('rtr_business-how-receive.text9')
								}}</router-link
								>{{ $t('rtr_business-how-receive.text10') }}<br />
								{{ $t('rtr_business-how-receive.text11') }}
							</p>
						</div>
					</div>
				</div>
			</div>
		</section>

		<section class="bg_gray">
			<div class="content_area">
				<div class="sub_content_box">
					<div class="d_flex align_items_center mb_15">
						<div class="img_box">
							<img src="@/assets/images/sub/business_receive_05.png" alt="" />
						</div>
						<div class="detail_box">
							<h2 class="title_m mb_10">
								{{ $t('rtr_business-how-receive.title7') }}
							</h2>
							<p class="body_m">
								{{ $t('rtr_business-how-receive.text12') }}
								{{ $t('rtr_business-how-receive.text13') }}
							</p>
						</div>
					</div>
					<p class="mb_5">
						<router-link to class="m_link_type_02" @click="notYet">
							{{ $t('rtr_business-how-receive.text14')
							}}<span class="CIRCLE_ARROW"></span>
						</router-link>
					</p>
					<p>
						<router-link to class="m_link_type_02" @click="notYet">
							{{ $t('rtr_business-how-receive.text15')
							}}<span class="CIRCLE_ARROW"></span>
						</router-link>
					</p>
				</div>
				<div class="sub_content_box">
					<div class="d_flex align_items_center mb_15">
						<div class="img_box">
							<img src="@/assets/images/sub/business_receive_08.png" alt="" />
						</div>
						<div class="detail_box">
							<h2 class="title_m mb_10">
								{{ $t('rtr_business-how-receive.title8') }}
							</h2>
							<p class="body_m ma_0">
								{{ $t('rtr_business-how-receive.text16') }}
								{{ $t('rtr_business-how-receive.text17') }}
							</p>
						</div>
					</div>
					<p>
						<router-link to class="m_link_type_02" @click="notYet">
							{{ $t('rtr_business-how-receive.text18')
							}}<span class="CIRCLE_ARROW"></span>
						</router-link>
					</p>
				</div>
				<div class="sub_content_box">
					<div class="d_flex align_items_center mb_15">
						<div class="img_box">
							<img src="@/assets/images/sub/business_receive_06.png" alt="" />
						</div>
						<div class="detail_box">
							<h2 class="title_m mb_10">
								{{ $t('rtr_business-how-receive.title9') }}
							</h2>
							<p class="body_m ma_0">
								{{ $t('rtr_business-how-receive.text19') }}
								{{ $t('rtr_business-how-receive.text20') }}
							</p>
						</div>
					</div>
					<p>
						<router-link to class="m_link_type_02" @click="notYet">
							{{ $t('rtr_business-how-receive.text21')
							}}<span class="CIRCLE_ARROW"></span>
						</router-link>
					</p>
				</div>
				<div class="sub_content_box">
					<div class="d_flex align_items_center">
						<div class="img_box">
							<img src="@/assets/images/sub/business_receive_09.png" alt="" />
						</div>
						<div class="detail_box">
							<h2 class="title_m mb_10">
								{{ $t('rtr_business-how-receive.title10') }}
							</h2>
							<p class="body_m ma_0">
								{{ $t('rtr_business-how-receive.text22') }}
								{{ $t('rtr_business-how-receive.text23') }}
							</p>
						</div>
					</div>
				</div>
				<div class="sub_content_box">
					<div class="d_flex align_items_center">
						<div class="img_box">
							<img src="@/assets/images/sub/business_receive_07.png" alt="" />
						</div>
						<div class="detail_box">
							<h2 class="title_m mb_10">
								{{ $t('rtr_business-how-receive.title11') }}
							</h2>
							<p class="body_m ma_0">
								{{ $t('rtr_business-how-receive.text24') }}
								<router-link to class="m_link_type_02" @click="notYet">
									{{ $t('rtr_business-how-receive.text25') }} </router-link
								>{{ $t('rtr_business-how-receive.text26') }}
							</p>
						</div>
					</div>
				</div>
				<div class="sub_content_box">
					<div class="d_flex align_items_center mb_15">
						<div class="img_box">
							<img src="@/assets/images/sub/business_receive_10.png" alt="" />
						</div>
						<div class="detail_box">
							<h2 class="title_m mb_10">
								{{ $t('rtr_business-how-receive.title12') }}
							</h2>
							<p class="body_m ma_0">
								{{ $t('rtr_business-how-receive.text27')
								}}{{ $t('rtr_business-how-receive.text28') }}
							</p>
						</div>
					</div>
					<p>
						<router-link to class="m_link_type_02" @click="notYet">
							{{ $t('rtr_business-how-receive.text29')
							}}<span class="CIRCLE_ARROW"></span>
						</router-link>
					</p>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import '@/assets/css/sub.m.css';
export default {
	name: 'Receive.m',
	methods: {
		notYet() {
			alert(this.$t('alert.not_yet'));
		},
	},
};
</script>

<style scoped></style>
